import { render, staticRenderFns } from "./PostChallengeForm.vue?vue&type=template&id=2a878f2c&scoped=true"
import script from "./PostChallengeForm.vue?vue&type=script&lang=ts"
export * from "./PostChallengeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a878f2c",
  null
  
)

export default component.exports